import { Controller } from '@hotwired/stimulus'
import { navigateFrame, debounce } from '../../modules/table_navigation'

export default class extends Controller {
  static targets = ['predicate', 'operator', 'value']

  connect() {
    this._debouncedUpdate = debounce(() => this.#apply())
    const active = this.predicateTargets.find(f => f.value !== '')
    if (active) {
      this.operatorTarget.value = active.dataset.predicate
      this.valueTarget.value = active.value
    }
  }

  update() {
    if (this.valueTarget.value) this.#apply()
  }

  updateDebounced() {
    this._debouncedUpdate()
  }

  #apply() {
    const op = this.operatorTarget.value
    const val = this.valueTarget.value

    this.predicateTargets.forEach(f => { f.value = '' })
    if (op && val) {
      const field = this.predicateTargets.find(f => f.dataset.predicate === op)
      if (field) field.value = val
    }

    navigateFrame(this.element.closest('form'))
  }
}
